import '@spartacus/product-configurator/common';
import '@spartacus/product-configurator/rulebased';
import {Observable} from 'rxjs';
import {DcpPriceCalculationBreakdown} from './dcp-price-price-display-data';

export interface KeyValuePair<T> {
  [key: string]: T;
}

export interface AddToCartProductData {
  code?: string;
  technicalName?: string;
}

export interface DcpOccAddToCartParameters {
  userId?: string;
  cartId?: string;
  product?: AddToCartProductData;
  quantity?: number;
  configId?: string;
  transactionType?: string;
  data?: KeyValuePair<any>;
  cancellationUrl?: string;
}

export interface IValidation {
  code: string;
  severity: 'error' | 'warning' | 'info' | 'success';
  description: string;
  descriptionText?: string;
  context?: any;
  button?: IValidationButton;
}

export interface IValidationButton {
  name: string;
  url?: string;
  target?: 'blank' | 'modal';
  style?: 'link' | 'button';
  content?: ValidationButtonContent;
}

export interface ValidationButtonContent {
  headline?: string;
  body?: string;
}

export enum DcpUiType {
  NEW = 'not_implemented',
  QUANTITY = 'quantity',
  READ_ONLY_QUANTITY = 'read_only_quantity',
  SPEND_AMOUNT = 'spend_amount',
  DATE = 'date',
  ADDON = 'addon',
  ADDON_RADIO = 'addon_radio',
  READ_ONLY_ADDON = 'read_only_addon',
}

export enum ButtonActionCodes {
  ADD_TO_CART = 'addToCart',
  EXTERNAL_CHECKOUT = 'externalCheckout',
  EXTERNAL_QUOTE = 'externalQuote',
  LEAD_BUY = 'leadBuy',
}

declare module '@spartacus/product-configurator/common' {
  namespace ConfiguratorRouter {
    export interface Data {
      externalAttributes?: ExternalAttribute[];
    }
  }
}

declare module '@spartacus/product-configurator/rulebased' {
  namespace Configurator {
    /* eslint-disable */
    enum UiType {}

    enum UpdateType {}

    enum GroupType {}

    export interface ValueSupplement {}

    export interface AttributeSupplement {}

    export interface GroupOverview {}

    export interface Overview {}

    export interface Image {}

    export interface AttributeOverview {}

    /* eslint-enable */

    export interface PriceSummary {
      priceSummaryDCP?: PriceSummaryDCP;
      pricingError?: boolean;
      pricingErrorCode?: string;
      pricingErrorMessage?: string;
    }

    export interface PriceSummaryDCP {
      id: string;
      items: PriceSummaryItem[];
      subtotalGroups: SubtotalGroup[];
    }

    export interface PriceSummaryItem {
      totalValue: string;
      totalGrossValue: string;
      grossValue: string;
      totalTaxValue: string | null;
      taxValue: string | null;
      netValue: string;

      [other: string]: any;
    }

    export interface SubtotalGroup extends PriceSummaryItem {
      code: 'all' | 'editions' | 'recurring' | 'editions_addon' | string;
      formattedValues: PriceSummaryItem;
      priceCalculationBreakdown?: DcpPriceCalculationBreakdown[];
    }

    export interface Configuration {
      validation?: IValidation[];
      buttonActions?: ButtonAction[];
      productName?: string;
      pdpUrl?: string;
    }

    export interface ButtonAction {
      code: string;
      description: string;
      type: string;
      targetUrl: string;
    }

    export interface Group {
      validation?: IValidation[];
      selectedSingleValue?: string;
    }

    export interface Attribute {
      hidden?: boolean;
      entryFieldMask?: string;
      validation?: IValidation[];
      longText?: string;
      longTextHTMLFormat?: boolean;
      attributeDescriptionText?: string;
      showSelectedHtml?: boolean;
      dcpUiType?: DcpUiType | UiType;
      addonName?: string;
      elementPlaceholder?: string;
    }

    export interface Value {
      selectedHtml?: string;
    }

    export interface AddToCartParameters {
      transactionType?: string;
      technicalName?: string;
      data?: KeyValuePair<any>;
      cancellationUrl?: string;
    }

    export interface UpdateConfigurationForCartEntryParameters {
      transactionType?: string;
      technicalName?: string;
    }
  }

  namespace OccConfigurator {
    /**
     *
     * An interface representing the variant configuration consumed through OCC.
     */
    export interface Configuration {
      validation?: IValidation[];
      buttonActions?: ButtonAction[];
      productName?: string;
      pdpUrl?: string;
      priceSummary?: OccConfigurator.PriceSummary;
    }

    export interface ButtonAction {
      code: string;
      description: string;
      type: string;
      targetUrl: string;
    }

    export interface PriceSummary {
      pricingError?: boolean;
      pricingErrorCode?: string;
      pricingErrorMessage?: string;
      priceSummaryDCP?: any;
    }

    export interface Group {
      validation?: IValidation[];
    }

    export interface Attribute {
      entryFieldMask?: string;
      validation?: IValidation[];
      longText?: string;
      longTextHTMLFormat?: boolean;
      attributeDescriptionText?: string;
      showSelectedHtml?: boolean;
      elementPlaceholder?: string;
    }

    export interface Value {
      longText?: string;
      selectedHtml?: string;
    }

    export interface AddToCartParameters {
      data?: KeyValuePair<any>;
    }

    export interface UpdateConfigurationForCartEntryParameters {
      transactionType?: string;
    }

    export interface AddToCartProductData {
      technicalName?: string;
    }

    export interface Validation extends IValidation {}

    export interface ValidationButton extends IValidationButton {}
  }
}

export interface ExternalAttribute {
  name: string;
  value: string;
}

export type ConfigLoadingState = {
  initialLoading: Observable<boolean>;
  configReseted: Observable<boolean>;
  updateFinished: Observable<boolean>;
};

//To ensure module argumentation is working, the file needs to be considered as module, therefore at least one export statement is required
export {};
